export default "__VITE_ASSET__bbYjsQNP__"